"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sharedUtils_1 = require("src/utils/sharedUtils");
const Abstract_1 = __importDefault(require("./Abstract"));
class GatewayWidget extends Abstract_1.default {
    constructor(parent) {
        console.log("[GatewayWidget.constructor]");
        super(parent);
        this.settings = {
            iframe: {
                id: "adopty_widget-main",
                allow: "clipboard-write",
                style: "display: none",
                src: `${sharedUtils_1.dev_env_object.WIDGET_BASE_URL}/widget`,
            },
        };
        this.identify = (data) => {
            console.log("[GatewayWidget.identify]");
            this.postMessage({ type: "identify", data: { key: this.parent.widget_key, data, token: this.parent.user_token } });
        };
        this.track_tour = (tour_id, data) => {
            if (!this.parent.user || this.parent.TourController.isDemoMode)
                return;
            console.log("[GatewayWidget.track]");
            this.postMessage({ type: "track_tour", data: { key: this.parent.widget_key, tour_id, data } });
        };
        this.createIframe();
    }
    onWidgetLoaded() {
        console.log("[GatewayWidget.onWidgetLoaded]");
        this.fetchData();
        this.parent.asyncApply();
    }
    fetchData() {
        console.log("[GatewayWidget.fetchData]");
        this.postMessage({ type: "fetchData", data: { key: this.parent.widget_key } });
    }
}
exports.default = GatewayWidget;
